import React from 'react'
import { connect } from 'react-redux'

let ErrorContainer = ({ error }) => (
  error
    ? <div className='container'>
        <div className='alert alert-danger'>
          {error}
        </div>
      </div>
    : null
)

function mapStateToProps({ error }) {
  return {
    error: error.err
  }
}

ErrorContainer = connect(mapStateToProps)(ErrorContainer)

export default ErrorContainer



// WEBPACK FOOTER //
// ./src/app/components/error-container.js